import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import type { ImageProps } from 'types/content-editor'
export const updateImageProp = (
  imageProps: ImageProps,
  prop: string,
  value: string,
  maxImageWidth?: number,
): ImageProps => {
  const result = cloneDeep(imageProps)

  if ((prop === 'width' || prop === 'height') && imageProps.aspectRatio) {
    if (prop === 'width') {
      const adjustedWidth =
        maxImageWidth && parseInt(value, 10) > maxImageWidth
          ? maxImageWidth
          : parseInt(value, 10)
      const height = adjustedWidth / (imageProps.aspectRatio || 1)
      set(result, 'height', Math.round(height))
      set(result, prop, adjustedWidth)
    } else {
      const width = parseInt(value, 10) * (imageProps.aspectRatio || 1)
      const adjustedWidth = Math.round(
        maxImageWidth && width > maxImageWidth ? maxImageWidth : width,
      )
      const adjustedHeight =
        Math.abs(adjustedWidth - width) > 1
          ? Math.round(adjustedWidth / (imageProps.aspectRatio || 1))
          : parseInt(value, 10)
      set(result, 'width', adjustedWidth)
      set(result, prop, adjustedHeight)
    } // set(result, prop, value)
  } else {
    set(result, prop, value)
  }

  return result
}
